function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M0 192V20h172v172z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.667 86c0 39.578-32.09 71.667-71.667 71.667-39.578 0-71.667-32.09-71.667-71.667 0-39.578 32.09-71.667 71.667-71.667 39.578 0 71.667 32.09 71.667 71.667z",
    style: {
      fill: "#2196f3"
    },
    transform: "translate(-15.644 -15.645) scale(1.2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.833 78.833h14.334v39.417H78.833Zm16.125-19.708c0 4.941-4.017 8.958-8.958 8.958s-8.958-4.017-8.958-8.958 4.017-8.958 8.958-8.958 8.958 4.017 8.958 8.958z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-15.644 -15.645) scale(1.2982)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInfo);
export default __webpack_public_path__ + "static/media/status-info.2ba63b7643dd963102dd60311c7b14a0.svg";
export { ForwardRef as ReactComponent };